// Global Instructions Rule Applied!

import React from 'react'
import { DocumentReportsForm } from './components/DocumentReportsForm.tsx'

export default function DocumentReportsPage() {
  return (
    <div className='h-full overflow-hidden'>
      <div className='w-full h-full flex flex-col bg-white p-2 overflow-hidden'>
        <DocumentReportsForm />
      </div>
    </div>
  )
}
